import { useEffect } from 'react';

const BASE_TITLE = 'Agrovid';

/** Fija el título de la pestaña como "<title> · Agrovid"; al desmontar vuelve a "Agrovid". */
export function usePageTitle(title: string) {
  useEffect(() => {
    document.title = title ? `${title} · ${BASE_TITLE}` : BASE_TITLE;
    return () => { document.title = BASE_TITLE; };
  }, [title]);
}
